import axios from 'axios';
// 토큰, 라우터, 알람 등은 각 앱의 구현체에서 주입 또는 커스텀 가능하도록
export function createAxiosInstance(tokenResolver, errorHandler, baseURL, accountTokenResolver) {
    const DEFAULT_TIMEOUT = 10000;
    const instance = axios.create({
        timeout: DEFAULT_TIMEOUT,
        headers: { 'Content-Type': 'application/json' },
        ...(baseURL && { baseURL }),
    });
    // Request: 토큰 삽입 및 타임아웃 설정
    // 참고: Axios의 postForm(), putForm() 메서드가 FormData 변환을 자동으로 처리합니다
    instance.interceptors.request.use(async (config) => {
        // 요청별 타임아웃이 이미 명시적으로 설정된 경우 그대로 사용
        // 기본값인 경우에만 URL 패턴에 따라 재설정
        const url = config.url || '';
        const isDefaultTimeout = !config.timeout || config.timeout === DEFAULT_TIMEOUT;
        if (isDefaultTimeout) {
            // 인증 관련 API: 5초
            if (url.includes('/auth/login') ||
                url.includes('/auth/logout') ||
                url.includes('/auth/refresh') ||
                url.includes('/auths/web/refresh')) {
                config.timeout = 5000;
            }
            // 파일 관련 API: 20초
            // FormData 체크가 가장 정확하므로 우선 사용
            else if (config.data instanceof FormData || // FormData를 사용하는 모든 요청 (가장 정확)
                url.includes('/file/upload') || // 파일 업로드 엔드포인트
                (url.includes('/qna') && (config.method === 'post' || config.method === 'put')) || // QNA 파일 업로드
                url.includes('/members/join/corporate') || // 법인 회원 등록 (파일 업로드 포함)
                url.includes('/members/join/individual') // 개인 회원 등록 (파일 업로드 포함)
            ) {
                config.timeout = 20000;
            }
            // 잔고 조회 API: 20초
            // next key를 통한 반복 조회 방식으로 지연될 가능성 있음
            else if (url.includes('/stocks/positions/all')) {
                config.timeout = 30000;
            }
            // 기본값(10초) 유지
        }
        // Access Token 삽입
        if (tokenResolver) {
            const token = await tokenResolver();
            if (token && config.headers) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        // Account Token 삽입
        if (accountTokenResolver) {
            const accountToken = await accountTokenResolver();
            if (accountToken && config.headers) {
                config.headers['X-Account-Token'] = accountToken;
            }
        }
        return config;
    }, (error) => Promise.reject(error));
    instance.interceptors.response.use((response) => response.data, async (error) => {
        if (errorHandler) {
            const result = await errorHandler(error);
            // errorHandler가 Promise를 반환한 경우 (예: 토큰 갱신 후 재시도)
            // 그 값을 반환하고, 그렇지 않으면 기존 에러를 reject
            return result !== undefined ? result : Promise.reject(error);
        }
        return Promise.reject(error);
    });
    return instance;
}
//# sourceMappingURL=axios.js.map